<template>
  <div class="ws-chips">
    <WsChip001
      v-for="(chip,chipIndex) in value"
      :key="chipIndex"
      :text="chip.text"
      :leading-icon="chip.icon"
      :leading-img="chip.image"
      :color="chip.color"
      :isWrap="chip.isWrap"
      :bold="chip.bold"
    />
  </div>
</template>
<script>
export default {
  name: "WsChips001",
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>